import instance from './common';

export const getRCAData = (reqBody) => {
  return instance.post('/appData/rca', reqBody);
};
